import clsx from 'clsx';
import { useField } from 'formik';
import { FocusEvent } from 'react';
import { Form } from 'react-bootstrap';

interface TextareaProps {
  name: string;
  placeholder?: string;
  maxLength?: number;
  minLength?: number;
  rows?: number;
  className?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  hideError?: boolean;
  onBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void;
}

function Textarea({
  name,
  placeholder,
  maxLength,
  minLength,
  rows = 4,
  className,
  label,
  required,
  disabled,
  hideError = false,
  onBlur,
}: TextareaProps) {
  const [field, meta, helpers] = useField(name);

  return (
    <Form.Group controlId={name} className={className}>
      <div>
        {label && (
          <Form.Label>
            {label}
            {required && <span className="required-asterisk"> *</span>}
          </Form.Label>
        )}
        <Form.Control
          as="textarea"
          rows={rows}
          className={clsx(meta.error && meta.touched && 'input-error')}
          {...field}
          placeholder={placeholder}
          maxLength={maxLength}
          minLength={minLength}
          disabled={disabled}
          aria-describedby={`${name}_error`}
          onBlur={(event: FocusEvent<HTMLTextAreaElement, Element>) => {
            helpers.setTouched(true);
            onBlur && onBlur(event);
          }}
        />
      </div>
      {!hideError && meta.error && meta.touched && <span className="text-error form-text">{meta.error}</span>}
    </Form.Group>
  );
}

export default Textarea;
